import { reactive, toRefs } from 'vue';
import type { NumbersState, SpotlightOptions } from '@/store/modules/numbers/numbers-types';
import {
  getSavedDataFromLocalStorage,
  useStateLocalstorageSync,
} from '@/utils/localStorage/localStorage';

const viewModeLSKey = 'number-flow-view-mode';
const columnWidthLSKey = 'number-flow-column-width-bbb11';

export const minColWidth = 435;

export const minWidthPadding = 20;

const numbersState = reactive<NumbersState>({
  numberTreeItems: {},
  documentReferences: {},
  initialDocumentReferences: {},
  numbersFlowStatus: '',
  numbersErrorMessage: '',
  numberToAddEvidence: null,
  numbersErrorData: null,
  numbersLoading: false,
  relatedInformation: {},
  isReviewed: false,
  evidencesToAddToNumber: null,
  evidenceToConnectToNumber: null,
  missingReferenceNumber: null,
  expandedNumber: null,
  spotlightOptions: {},
  spotlightActive: false,
  spotlightedNumbers: [],
  viewModes: getSavedDataFromLocalStorage([viewModeLSKey])[viewModeLSKey],
  numbersColumnWidth:
    getSavedDataFromLocalStorage([columnWidthLSKey])[columnWidthLSKey] || minColWidth,
  highlightedCalculationTerm: undefined,
});

export const {
  documentReferences,
  initialDocumentReferences,
  isReviewed,
  numbersFlowStatus,
  numberTreeItems,
  numbersErrorData,
  numbersErrorMessage,
  relatedInformation,
  viewModes,
  evidencesToAddToNumber,
  evidenceToConnectToNumber,
  missingReferenceNumber,
  expandedNumber,
  spotlightOptions,
  spotlightActive,
  spotlightedNumbers,
  numbersColumnWidth,
  highlightedCalculationTerm,
} = toRefs(numbersState);

useStateLocalstorageSync(viewModeLSKey, viewModes);
useStateLocalstorageSync(columnWidthLSKey, numbersColumnWidth);

export function deactivateSpotlight() {
  spotlightActive.value = false;
  spotlightedNumbers.value = [];
  spotlightOptions.value = {};
}

export function activateSpotlight(numberIds: string[], options: SpotlightOptions = {}) {
  spotlightActive.value = true;
  spotlightedNumbers.value = numberIds;
  spotlightOptions.value = options;
}

export default numbersState;
